import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { CoaterLicense } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { PageComponent } from '@workspace-app/shared';
import { LicenseViewComponent } from './license-view.component';
import { LicenseDataService } from '../../license-data.service';

@Component({
  selector: 'app-license-standalone-view',
  standalone: true,
  imports: [PageComponent, LicenseViewComponent, AsyncPipe],
  providers: [DialogService, MessageService],
  template: `
    @if (license$ | async; as license) {
      <app-page [title]="'License ' + (license.completeLicenseNumber || '')" [showBackButton]="true">
        <app-license-view [license]="license" />
      </app-page>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        width: 100%;
      }
    `,
  ],
})
export class LicenseStandaloneViewComponent {
  private route = inject(ActivatedRoute);
  private licenseDataService = inject(LicenseDataService);

  license$: Observable<CoaterLicense>;

  constructor() {
    this.license$ = this.licenseDataService.fetchLicense(this.route.snapshot.params['id']);
  }
}
